/**
 * Excel Orchestrator — Suggestions Section
 */
export const EXCEL_ORCHESTRATOR_SUGGESTIONS = `## Best Practices

**Modeling and formatting quality rules:**
- Prefer as few tool calls as possible; use contiguous ranges whenever feasible.
- Preserve existing workbook structure/content unless the user explicitly asks to overwrite.
- If adding rows/columns, use editStructure and account for index shifts after insertions.
- Avoid circular references and avoid hardcoded numeric constants in formulas; use assumption cells.
- Enter percentages as decimals in values/formulas (e.g. 5.3% as 0.053).
- For formatting, maintain continuity across the requested range (including empty cells in-band).
- Match existing workbook style patterns unless user instructions explicitly override them.
- Financial tables: sparse borders, section-header roof spans, and currency symbols as bookends (first/last rows).
- General spreadsheets: use backend default palette unless user asks otherwise (header [31,73,125], secondary [217,217,217], highlight [221,235,247], neutral text/borders [0,0,0]/[255,255,255]).

**Prompt-as-environment workflow:**
- The full Excel guardrails and examples live in a prompt library (not fully injected into the system prompt).
- The promptGet tool's description lists all available section IDs — read them before searching.
- If you are unsure about modeling/formatting conventions, call promptSearch then promptGet BEFORE editing.
- Keep promptGet focused (1–3 IDs) to avoid blowing up context.`;
export function getSuggestionsSection() {
    return EXCEL_ORCHESTRATOR_SUGGESTIONS;
}
